import React from 'react';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';

interface EditIconButtonProps {
  onClick: () => void;
}

const EditIconButton: React.FC<EditIconButtonProps> = ({ onClick, ...props }) => {
  return (
    <IconButton aria-label="edit" onClick={onClick} {...props}>
      <Edit fontSize="small" />
    </IconButton>
  );
};

export default EditIconButton;
